import { ZAP_APP_PATH_PREFIXES } from '@ctw/shared/utils/url';

// Rewrites a ZAP/smart-on-fhir pathname to the canonical DataDog RUM view name
// `/patients/?/{page}`, stripping the app-specific mount prefix (`/v2`, `/vim/v1`,
// `/zap-v2`, …). The literal `?` is DataDog's group token: this matches the shape
// DataDog already derives for the standalone app (`/patients/{uuid}/{page}`), so a
// page groups together regardless of which app served it. Returns null when the
// pathname carries no known prefix, so the caller leaves the automatic name alone.
export const computeCanonicalRumViewName = (pathname: string): string | null => {
  const prefix = ZAP_APP_PATH_PREFIXES.find(
    (candidate) => pathname === candidate || pathname.startsWith(`${candidate}/`),
  );
  if (prefix === undefined) {
    return null;
  }

  const page = pathname.slice(prefix.length);
  return `/patients/?${page}`;
};
